<template>
  <q-page class="flex column">
    <PowerBIReportEmbedded
      reportId="4ed59a38-9406-4382-b81c-62ef0b986daf"
      :showFilters="false"
      :showPageNavigation="false"
    />
  </q-page>
</template>

<script>
import PowerBIReportEmbedded from "@/components/PowerBIReportEmbedded.vue";
export default {
  name: "PerformanceReportEmbedded",
  components: {
    PowerBIReportEmbedded,
  },
};
</script>
